import React from 'react';
import {
  PossWarrantyIcon,
  WarrantyIcon,
} from '../../../../../../../../resource/icons';
import { warrantyIds } from '../../../../config';

const IconComponent = ({ warrantyId, ...props }) => {
  if (warrantyId === warrantyIds.warranty) {
    return <WarrantyIcon {...props} />;
  }

  return (
    <PossWarrantyIcon
      {...props}
      grey={warrantyId === warrantyIds.notWarranty ? 'true' : undefined}
    />
  );
};

export default IconComponent;
